// The canonical trilingual content-language union for the HKDC site: the three
// languages every exhibit / zone / exhibition title, description, narration and
// media item is authored in. One name, one ordering (tc, en, sc), one source of
// truth. `AudioLanguage` (useTextToSpeech) and `NarrationLanguage` (lib/media)
// are kept as aliases of this so co-located code stops importing three names for
// the same concept. Backend twin: app/schemas/media.py NARRATION_LANGS.

export type ContentLanguage = "tc" | "en" | "sc";

export const CONTENT_LANGUAGES = ["tc", "en", "sc"] as const;
